import axios from 'axios';
import { API_URL } from '../config';

const base = `${API_URL}/billing`;

export async function fetchBillingPlans() {
  const { data } = await axios.get(`${base}/plans`);
  return data;
}

export async function createStripeCheckout(organizationId, planId, billingCycle) {
  const { data } = await axios.post(`${base}/subscription`, {
    organization_id: organizationId,
    plan_id: planId,
    billing_cycle: billingCycle,
  });
  return data;
}

export async function changePlan(organizationId, planId, billingCycle) {
  const { data } = await axios.patch(`${base}/subscription/plan`, {
    organization_id: organizationId,
    plan_id: planId,
    billing_cycle: billingCycle,
  });
  return data;
}

export async function previewDowngrade(organizationId, targetPlanId) {
  const { data } = await axios.get(`${base}/downgrade-preview`, {
    params: { organization_id: organizationId, target_plan_id: targetPlanId },
  });
  return data;
}

export async function previewProration(organizationId, newPlanId, newCycle) {
  const { data } = await axios.get(`${base}/proration-preview`, {
    params: {
      organization_id: organizationId,
      new_plan_id: newPlanId,
      new_cycle: newCycle,
    },
  });
  return data;
}

export async function cancelPendingDowngrade(organizationId) {
  const { data } = await axios.delete(`${base}/subscription/pending-downgrade`, {
    params: { organization_id: organizationId },
  });
  return data;
}

export async function cancelSubscription(organizationId) {
  const { data } = await axios.delete(`${base}/subscription`, {
    params: { organization_id: organizationId },
  });
  return data;
}

export async function openBillingPortal(organizationId) {
  const { data } = await axios.get(`${base}/portal`, {
    params: { organization_id: organizationId },
  });
  return data;
}

export async function fetchInvoices(organizationId, limit = 20) {
  const { data } = await axios.get(`${base}/invoices`, {
    params: { organization_id: organizationId, limit },
  });
  return data;
}

export async function fetchPlanContext(organizationId) {
  const { data } = await axios.get(`${API_URL}/plan/context`, {
    params: { organization_id: organizationId },
  });
  return data;
}

export async function fetchPricingCatalog() {
  const { data } = await axios.get(`${API_URL}/pricing/catalog`);
  return data;
}

export async function startSkipCashCheckout(organizationId, payload) {
  const { data } = await axios.post(
    `${API_URL}/organizations/${organizationId}/payments/checkout`,
    payload
  );
  return data;
}

export async function reactivateSubscription(organizationId) {
  const { data } = await axios.post(`${base}/subscription/reactivate`, {
    organization_id: organizationId,
  });
  return data;
}

export function yearlyMonthlyEquivalent(plan) {
  const yearly = Number(plan?.price_usd_yearly) || 0;
  if (yearly <= 0) return 0;
  return Math.round((yearly / 12) * 100) / 100;
}

export function planDisplayPrice(plan, cycle) {
  if (!plan || plan.pricing_display === 'contact_sales') return null;
  if (cycle === 'yearly') {
    const eq = yearlyMonthlyEquivalent(plan);
    return { amount: eq, suffix: '/mo', note: 'billed annually', annual: Number(plan.price_usd_yearly) || 0 };
  }
  return { amount: Number(plan.price_usd) || 0, suffix: '/mo', note: null, annual: null };
}
